const ADDRESS_LENGTH = 32;
export default {
  isValidAddress(address) {
    return this.isValidSuiAddress(address);
  },

  /**
   * 
   * Validate SUI Addresses
   * https://github.com/MystenLabs/sui/blob/f533b3f435903a858991cff798dbdfc1e7f9f452/sdk/typescript/src/types/common.ts#L92
   * @param {string} address 
   * @returns {boolean}
   */
  isValidSuiAddress(address) {
    return this.isHex(address) && this.getHexByteLength(address) === ADDRESS_LENGTH;
  },
  isHex(value) {
    return /^(0x|0X)?[a-fA-F0-9]+$/.test(value) && value.length % 2 === 0;
  },
  getHexByteLength(value) {
    return /^(0x|0X)/.test(value) ? (value.length - 2) / 2 : value.length / 2;
  },
};
